﻿import React from 'react';

//lib
import { v4 as uuidv4 } from 'uuid';

// components 
import PossessionsTableContent from './PossessionsTableContent';
import PossessionsTableContentChart from './PossessionsTableContentChart';
import PossessionsTableHeader from './PossessionsTableHeader';

const PossessionsTable = ({
    content,
    selected,
    heading,
    selectedRowIndex,
    expanded,
    setExpanded
}) => {

    return (
        <table className="possessions__table">
            <PossessionsTableHeader
                content={content}
                selected={selected}
                heading={heading}
            />

            {content.insuranceCoverage.map(({ title, description, levels }, index) => (

                <React.Fragment key={uuidv4()}>

                    {levels.length > 0 &&
                        <PossessionsTableContentChart
                            selectedRowIndex={selectedRowIndex}
                            content={content}
                            levels={levels}
                            description={description}
                            title={title}
                            index={index}
                            expanded={expanded}
                            setExpanded={setExpanded}
                        />
                    }

                    {levels.length <= 0 &&
                        <PossessionsTableContent  
                            content={content}
                            description={description}
                            title={title}
                            index={index}
                            expanded={expanded}
                            setExpanded={setExpanded}
                        />

                    }
                </React.Fragment>
            ))}
        </table>
     )
};

export default PossessionsTable;

